export default __webpack_public_path__ + "static/media/img--LUX-dining-1.04d4d60d.jpg";